export const getEventProperty = (eventName, name, value) => {
  return {
    eventName,
    name,
    value,
  };
};
